import React from "react";
import { useSearchClient } from "./searchClient";
import { SearchQuery, SearchResponse } from "@algolia/client-search/dist/node";
import { HitRecord } from "./mapHitToListing";

export default function useCustomSearch(searchRequests: SearchQuery[], remoteIp?: string) {
  const [results, setResults] = React.useState<SearchResponse<HitRecord>[]>([]);
  const [searching, setSearching] = React.useState(true);
  const searchClient = useSearchClient(remoteIp);

  function runSearch() {
    if (!searchRequests.length) return;

    setSearching(true);
    searchClient.search({ requests: searchRequests }).then(({ results }) => {
      setResults(results as SearchResponse<HitRecord>[]);
      setSearching(false);
    });
  }

  React.useEffect(() => {
    runSearch();

    return () => {
      setResults([]);
      setSearching(false);
    };
  }, []);

  return { results, searching };
}
